/** Wrapper class for passing default data types by reference */
export class WrappedValue<T> {
    v: T;

    constructor(v: T) {
        this.v = v;
    }
}
